<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        :title="alter ? 'Alterar Fator' : 'Incluir Fator'"
                        type="fieldset"
                    >
                        <rkm-row>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    :validations="validations.fator"
                                    label="Fator"
                                    v-model="model.fator"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-select
                                    :options="data.form.operacoes"
                                    :validations="validations.operacoes"
                                    label="Operação"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.operacaoId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-radio-group
                                    v-model="model.tipo"
                                    :validations="validations.tipo"
                                    label="Tipo"
                                >
                                    <rkm-form-radio :value="enums.tipoFator.VARIAVEL">Variável</rkm-form-radio>
                                    <rkm-form-radio :value="enums.tipoFator.CONSTANTE">Constante</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    :validations="model.tipo == enums.tipoFator.CONSTANTE ? validations.valor : {}"
                                    label="Valor"
                                    v-model="model.valor"
                                    ref="valor"
                                    :disabled="model.tipo != enums.tipoFator.CONSTANTE"
                                    v-money="money"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-radio-group
                                    v-model="model.exponenciacao"
                                    label="Exponenciação"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-radio-group
                                    :validations="model.exponenciacao == true ? validations.exponenciacaoTipo : {}"
                                    v-model="model.exponenciacaoTipo"
                                    label="Tipo Exponenciação"
                                    :disabled="model.exponenciacao != true"
                                >
                                    <rkm-form-radio :value="enums.tipoFator.VARIAVEL">Variável</rkm-form-radio>
                                    <rkm-form-radio :value="enums.tipoFator.CONSTANTE">Constante</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    :validations="model.exponenciacaoTipo == enums.tipoFator.CONSTANTE ? validations.valor : {}"
                                    label="Valor Exponenciação"
                                    v-model="model.exponenciacaoValor"
                                    ref="exponenciacaoValor"
                                    :disabled="model.exponenciacaoTipo != enums.tipoFator.CONSTANTE"
                                    v-money="money"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    :validations="validations.ordem"
                                    label="Ordem"
                                    v-model="model.ordem"
                                    number
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-0 text-nowrap">
                                <rkm-button
                                    :label="false"
                                    @click="add"
                                    color="primary"
                                >
                                    {{ alter ? 'Alterar' : 'Incluir' }}

                                </rkm-button>

                                <rkm-button
                                    :label="false"
                                    @click="resetForm"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            v-if="!alter"
            @handleAlter="handleAlter"
            :items="data.model.fatores"
        />
    </div>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Enums.
import tipoFator from '@/enums/exame-laboratorial/tipoFator'

// Components.
import List from './List'

//Directives
import { VMoney } from 'v-money'

export default {
    components: { List },
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                fator: {
                    required: true,
                    max: 50,
                    min: 3,
                },
                valor: {
                    max: 16,
                    min_value: 0.000001
                },
                operacoes: {
                    required: true,
                },
                ordem: {
                    required: true,
                },
                tipo: {
                    required: true,
                },
                exponenciacaoTipo: {
                    required: true,
                }
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    data: () => ({
        model: {
            id: '',
            fator: '',
            operacaoId: null,
            operacaoDescricao: '',
            tipo: null,
            valor: null,
            exponenciacao: false,
            exponenciacaoTipo: null,
            exponenciacaoValor: null,
            ordem: null,
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 6,
          masked: false
        },
        index: null,
        alter: false,
        enums: {
            tipoFator
        },
    }),
    methods: {
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    const fator = this.clone(this.model)

                    fator.operacaoDescricao = this.data.form.operacoes.find(u => u.id === this.model.operacaoId).descricao

                    if (this.hasIndex) {

                        const objIndex = this.data.model.fatores.findIndex((obj => obj.id == this.model.id));

                        this.$set(this.data.model.fatores, objIndex, this.clone(fator))


                    } else {

                        fator.id = this.uniqueId('fator' + new Date().getTime())

                        this.data.model.fatores.push(fator)
                    }

                    this.$emit('handleSave', this.data.model.fatores)

                    this.alter = false

                    this.resetForm()
                })
        },
        handleAlter(index, item) {

            this.resetForm()

            this.alter = true

            this.index = index
            this.model.id = item.id
            this.model.fator = item.fator
            this.model.operacaoId = item.operacaoId
            this.model.operacaoDescricao = item.operacaoDescricao
            this.model.tipo = item.tipo
            this.model.valor = item.valor
            this.model.exponenciacao = item.exponenciacao
            this.model.exponenciacaoTipo = item.exponenciacaoTipo
            this.model.exponenciacaoValor = item.exponenciacaoValor
            this.model.ordem = item.ordem

            if (item.valor == '0,000000') {
                this.$refs.valor.$el.getElementsByTagName('input')[0].value = 0
            } else {
                this.$refs.valor.$el.getElementsByTagName('input')[0].value = item.valor
            }

            if (item.exponenciacaoValor == '0,000000') {
                this.$refs.exponenciacaoValor.$el.getElementsByTagName('input')[0].value = 0
            } else {
                this.$refs.exponenciacaoValor.$el.getElementsByTagName('input')[0].value = item.exponenciacaoValor
            }
        },
        resetForm() {

            this.index = null
            this.model.id = ''
            this.model.fator = ''
            this.model.operacaoId = null
            this.model.operacaoDescricao = ''
            this.model.tipo = null
            this.model.valor = null
            this.model.exponenciacao = false
            this.model.exponenciacaoTipo = null
            this.model.exponenciacaoValor = null
            this.model.ordem = null

            this.$refs.valor.$el.getElementsByTagName('input')[0].value = 0
            this.$refs.exponenciacaoValor.$el.getElementsByTagName('input')[0].value = 0

            this.alter = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        id: { type: Number }
    },
}
</script>